import { useState, useCallback, useMemo } from 'react';
import { executeMutation } from '../mutations/executeMutation';
import { usePulseClient } from './shared';
const initialState = {
  loading: false,
  error: null,
  data: undefined
};
export function useMutation(definition) {
  const client = usePulseClient();
  const [state, setMutationState] = useState(initialState);
  const mutate = useCallback(async (params, overrides) => {
    if (!client) {
      return Promise.reject(new Error('Pulse client was not found in context — did you forget to provide it?'));
    }
    setMutationState({
      loading: true,
      error: null,
      data: undefined
    });
    try {
      const result = await executeMutation(definition, params, client, overrides);
      setMutationState({
        loading: false,
        error: null,
        data: result
      });
      return result;
    } catch (error) {
      setMutationState({
        loading: false,
        error,
        data: undefined
      });
      throw error;
    }
  }, [client, definition]);
  const reset = useCallback(() => {
    setMutationState(initialState);
  }, []);
  return useMemo(() => [mutate, Object.assign({}, state, {
    reset
  })], [mutate, state, reset]);
}